import {Box, Card, Tab, Tabs} from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import React, {useEffect} from "react";
import TabPanel from "../../helpers/TabPanel";
import Position from "./Position";
import StudyField from "./StudyField";
import {connect} from "react-redux";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";

function RecruitmentSettings(props) {
    const {SetSelectedMenu} = props;
    const [tabValue, setTabValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };


    useEffect(() => {
        SetSelectedMenu({
            menu: "recruitment_settings",
            title: "Recruit Management"
        })
    }, []);

    return <div>
        <Card>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Positions" {...a11yProps(0)} />
                    <Tab label="Field of Study" {...a11yProps(1)} />
                </Tabs>
            </Box>
            <TabPanel index={0} value={tabValue} p={0}>
                <Position {...props}/>
            </TabPanel>
            <TabPanel index={1} value={tabValue} p={0}>
                <StudyField {...props}/>
            </TabPanel>
        </Card>
    </div>
}

export default connect(null,mapDispatchToProps)(RecruitmentSettings);
